export const About = (props) => {
  return (
    <div id="about">
      <div id="about-anchor" className="anchor"></div>
      <div className="container">
        <div className="d-none d-lg-block">
          <div className="row">
            <div className="col-6">
              {" "}
              <img src="/assets/img/home/pictures/about01.jpg" className="img-fluid" alt="" />{" "}
            </div>
            <div className="col-6">
              <div className="about-text">
                <h2>{props.data ? props.data.title : "loading..."}</h2>
                <p>{props.data ? props.data.paragraph1 : "loading..."}</p>
                <p>{props.data ? props.data.paragraph2 : "loading..."}</p>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-6">
              <div className="about-text">
                <p>{props.data ? props.data.paragraph3 : "loading..."}</p>
              </div>
            </div>
            <div className="col-6">
              {" "}
              <img src="/assets/img/home/pictures/about02.jpg" className="img-fluid" alt="" />{" "}
            </div>
          </div>
        </div>
        <div className="d-none d-md-block d-lg-none">
          <div className="row">
            <div className="col-6">
              {" "}
              <img src="/assets/img/home/pictures/about01.jpg" className="img-fluid" alt="" />{" "}
            </div>
            <div className="col-6">
              <div className="about-text">
                <h2>{props.data ? props.data.title : "loading..."}</h2>
                <p>{props.data ? props.data.paragraph1 : "loading..."}</p>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-12">
              <p>{props.data ? props.data.paragraph2 : "loading..."}</p>
            </div>
          </div>
          <div className="row">
            <div className="col-6">
              <div className="about-text">
                <p>{props.data ? props.data.paragraph3 : "loading..."}</p>
              </div>
            </div>
            <div className="col-6">
              {" "}
              <img src="/assets/img/home/pictures/about02.jpg" className="img-fluid" alt="" />{" "}
            </div>
          </div>
        </div>
        <div className="d-block d-md-none text-center">
          <div className="row">
            <h2 className="centered-title">{props.data ? props.data.title : "loading..."}</h2>
          </div>
          <div className="row">
            <div className="col-12">
              {" "}
              <img src="/assets/img/home/pictures/about01.jpg" className="img-fluid" alt="" />{" "}
            </div>
            <div className="col-12">
              <div className="about-text">
                <p>{props.data ? props.data.paragraph1 : "loading..."}</p>
                <p>{props.data ? props.data.paragraph2 : "loading..."}</p>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-12">
              {" "}
              <img src="/assets/img/home/pictures/about02.jpg" className="img-fluid" alt="" />{" "}
            </div>
            <div className="col-12">
              <div className="about-text">
                <p>{props.data ? props.data.paragraph3 : "loading..."}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
